import React from 'react';
import {
  Radio, RadioChangeEvent,
} from '@revfluence/fresh';
import { capitalize, isEmpty } from 'lodash';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@frontend/shadcn/components/ui/accordion';
import { DataTable } from '@frontend/app/refresh-components/DataTableV2/Table';
import { TMember } from '../../../MembersWizard/types';
import { CustomColumn } from '../../RefreshManageOffer';

interface ActivateDeactivatePayoutData {
  key: number;
  name: string;
  code: string;
  payoutId?: number;
  status: string;
  affiliateLink?: string;
}
interface IProps {
  onChange: (e: RadioChangeEvent) => void;
  activeOrDeactive: string;
  memberToOperate: TMember[];
  selectedMembers?: readonly TMember[];
  activateDeactivatePayoutData: ActivateDeactivatePayoutData[];
  columns: CustomColumn[];
}

const RefreshManageOfferActivation: React.FC<IProps> = ({
  onChange,
  activeOrDeactive,
  memberToOperate,
  selectedMembers,
  activateDeactivatePayoutData,
  columns,
}) => (
  <div className="flex flex-col gap-4">
    <p className="text-sm font-medium text-grey-6 m-0">Activate/Deactivate Members</p>
    <p className="text-xs font-medium text-grey-6 m-0">{selectedMembers.length} {' '}{selectedMembers.length === 1 ? 'Member' : 'Members'}{' '}Selected</p>
    <Radio.Group name="radiogroup" onChange={onChange}>
      <Radio value="activate">
        Activate
        {' '}
      </Radio>
      <Radio value="deactivate">Deactivate </Radio>
    </Radio.Group>

    {!isEmpty(activeOrDeactive) && (
      <Accordion type="single" collapsible className="w-full">
        <AccordionItem value="item-1" className="!border-none">
          <AccordionTrigger className=" border border-grey-2 hover:no-underline hover:bg-grey-1 hover:border-grey-5 hover:text-grey-5 px-3 py-2 rounded-xl m-0 justify-between">
            {capitalize(activeOrDeactive)}
            {' '}
            {memberToOperate.length}
            {' '}
            {memberToOperate.length === 1 ? 'Member' : 'Members'}
          </AccordionTrigger>
          <AccordionContent>
            <DataTable
              columns={columns}
              data={activateDeactivatePayoutData}
            />
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    )}
  </div>
);

export default RefreshManageOfferActivation;
